import $ from "jquery";

(function () {
    const deliveryCheck = {
        init: function () {
            $(".edit-address,.destroy-address").on("click", function (e) {
                e.stopPropagation();
            });

            // Check delivery address
            $(".delivery-block").on("click", function () {
                if ($(this).hasClass('active') === false) {
                    let id = $(this).find("input[name=address]:radio").attr("id");

                    $.ajax({
                        type: "get",
                        url: "/account/addresses/" + id + "/check",
                        dataType: "json",
                        success: function (data) {
                            if (data.success === true) {
                                $("#address-check").text(data.message).addClass("alert-success").show();
                                setTimeout(function () {
                                    $("#address-check").slideUp();
                                }, 2000);
                            }
                        }
                    });
                }
            });
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/modules/delivery.js